<script>
</script>

<div class="lead">
	<div />
	<div>
		<div>
			<div class="kicker">FAQ zum Neustart</div>
			<h1>Die wichtigsten Fragen und Antworten zum neuen Tagesspiegel</h1>
			<p>
				Muss ich etwas tun, um den neuen Tagesspiegel zu erhalten? Wo finde ich die bekannten Ressorts in der neuen
				Zeitung? Alle Antworten in unserem FAQ-Dokument.
			</p>
		</div>
	</div>
</div>

<style lang="scss">
	@import "./main.scss";
	.lead {
		display: flex;
		height: 748px;
		min-width: 0;
		margin-top: 70px;
		margin-bottom: 50px;

		@media (max-width: 960px) {
			margin-top: 60px;
		}

		@media (max-width: 480px) {
			margin-top: 50px;
		}

		@media (max-width: $breakpoint-desktop-l) {
			height: 600px;
		}

		@media (max-width: $breakpoint-tablet-s) {
			flex-direction: column-reverse;
			height: auto;
		}

		> div:nth-child(1) {
			width: 100%;
			//max-width: 620px;
			flex: 0 0 50%;
			background-color: rgb(231, 210, 128);
			background-image: url("assets/images/lead_content.png"),
			linear-gradient(180deg, #E11860 0%, #E62565 14.58%, #F7AF6F 76.04%, #FAF0C3 100%);
			background-size: 500px, cover;
			background-position: center center, center center;
			background-repeat: no-repeat, repeat;

			@media (max-width: $breakpoint-desktop-l) {
				background-size: 400px, cover;
			}

			@media (max-width: $breakpoint-tablet-s) {
				height: 400px;
				align-self: center;
				background-size: 300px, cover;
				flex: 0 0 auto;
			}

			@media (max-width: $breakpoint-mobile-l) {
				width: 100%;
			}
		}

		> div:nth-child(2) {
			width: 50%;
			> div {
				max-width: 580px;
				margin: 0 auto;
				margin-top: 120px;
				padding: 0 40px;
				box-sizing: border-box;

				@media (max-width: $breakpoint-desktop-l) {
					margin-top: 80px;
				}

				@media (max-width: $breakpoint-tablet-s) {
					margin-top: 25px;
					margin-left: auto;
					margin-right: auto;
					padding: 0 20px;
				}

				@media (max-width: $breakpoint-mobile-s) {
					margin-top: 25px;
					padding: 0 10px;
				}

				div {
					display: none;
					font-family: $ff-sans;
					font-size: 20px;
					line-height: 24px;
					font-weight: 600;
					text-align: center;

					@media (max-width: $breakpoint-tablet-s) {
						display: block;
						width: auto;
					}
				}

				h1 {
					font-weight: 700;
					font-family: $ff-serif;
					font-size: 48px;
					line-height: 60px;

					@media (max-width: $breakpoint-tablet-l) {
						font-size: 42px;
						line-height: 52px;
					}

					@media (max-width: $breakpoint-tablet-s) {
						font-size: 36px;
						line-height: 45px;
						text-align: center;
					}

					@media (max-width: $breakpoint-mobile-m) {
						font-size: 32px;
						line-height: 40px;
					}
				}

				p {
					font-family: $ff-sans;
					font-weight: 400;
					font-size: 18px;
					line-height: 24px;
					padding: 0;
					margin: 0;
					max-width: none;
					width: auto;

					@media (max-width: $breakpoint-desktop-l) {
						background-size: 400px, cover;
					}

					@media (max-width: $breakpoint-tablet-s) {
						display: none;
					}
				}
			}

			@media (max-width: $breakpoint-tablet-s) {
				width: auto;
			}
		}
	}
</style>
